<script >
    import Me from './Me.svelte';

    export let title = "Coffee, Bagel, Data";

</script>
<svelte:head>
<title>CoffeeBagelData</title>
    <link href='https://fonts.googleapis.com/css?family=Caveat' rel='stylesheet'>
    <link rel='icon' type='image/png' href='/favicon1.png'>
    <!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-LGW4Z9NZKJ"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-LGW4Z9NZKJ');
</script>
</svelte:head>


        <header class = "title">

           <Me/>

            <h1 class ="name">
                <a href="#/">  {title}</a></h1>


        </header>


<style>
    .title{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        border-bottom: 1px solid white;

    }
    .name{
        margin: auto;
        font-family: 'Caveat';
        font-size: 3em;
        color: white;
        text-align: center;
        margin-left:20px;
    }
    /*.a:visited{text-decoration:none }*/
    a{
        font-style:  italic;
        color: white;

    }

    a:hover{
        font-weight: bolder;
        text-decoration: none;
        color:black;
    }
</style>